import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import type { Language } from '../types';
import memberCopyData from '../data/memberCopy';

const categories = [
  ['shopCategoryColorless','/colorless-diamonds.html'],['shopCategoryFancy','/fancy-color-diamonds.html'],
  ['shopCategoryRuby','/ruby.html'],['shopCategorySapphire','/sapphire.html'],['shopCategoryEmerald','/emerald.html'],
  ['shopCategoryParaiba','/paraiba.html'],['shopCategoryOther','/other-colored-stones.html'],['shopCategoryPearls','/pearls.html'],['shopCategoryJade','/jade.html']
] as const;

export function Header() {
  const [open, setOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();
  const { profile } = useAuth();
  const close = () => setOpen(false);
  const memberCopy=memberCopyData as Record<Language,Record<string,string>>;
  const memberLabel = profile ? (memberCopy[language]?.myAccount||'My Account') : (memberCopy[language]?.signIn||'Sign In');
  return <>
    <a className="skip-link" href="#main">{t('skip','Skip to content')}</a>
    <div className="announcement">{t('announcement','J’AIME FINE JEWELLERY™ · VICTORIA, BRITISH COLUMBIA')}</div>
    <header className="site-header" id="top">
      <button aria-controls="mobile-nav" aria-expanded={open} className="menu-button" type="button" onClick={() => setOpen(v=>!v)}>{t('menu','Menu')}</button>
      <nav aria-label={t('ariaPrimaryNav','Primary navigation')} className="desktop-nav nav-left">
        <div className="nav-dropdown">
          <Link aria-haspopup="true" className="nav-dropdown-trigger" to="/shop.html">{t('navShop','SHOP')}</Link>
          <div className="nav-dropdown-menu">{categories.map(([key,to])=><Link key={to} to={to}>{t(key,key)}</Link>)}</div>
        </div>
        <Link to="/fancy-color-diamonds.html">{t('navDiamonds','FANCY COLOUR DIAMONDS')}</Link>
      </nav>
      <Link aria-label={t('ariaHome','J’aime Fine Jewellery home')} className="brand" to="/">
        <img alt="J’aime Fine Jewellery" src="/assets/images/brand-wordmark-clean.png" />
      </Link>
      <div className="header-right">
        <nav aria-label={t('ariaSecondaryNav','Secondary navigation')} className="desktop-nav nav-right">
          <Link to="/maison.html">{t('navHouse','Maison')}</Link>
          <Link to="/founder.html">{t('navFounder','Founder')}</Link>
          <Link to="/payment.html">{t('navPayment','Payment')}</Link>
          <Link className="member-nav-link" to={profile?'/account.html':'/member.html'}>{memberLabel}</Link>
        </nav>
        <label className="language-control">
          <span className="sr-only">{t('languageLabel','Language')}</span>
          <select aria-label={t('ariaLanguage','Language')} className="language-select" value={language} onChange={e=>setLanguage(e.target.value as Language)}>
            <option value="en">EN</option><option value="zh">中文</option><option value="fr">FR</option>
          </select>
        </label>
        <img alt="" className="header-monogram" src="/assets/images/brand-monogram-clean.png" />
      </div>
      <nav aria-label={t('ariaMobileNav','Mobile navigation')} className={`mobile-nav${open?' open':''}`} id="mobile-nav">
        <Link onClick={close} to="/shop.html">{t('navShop','SHOP')}</Link>
        <div className="mobile-subnav">{categories.map(([key,to])=><Link key={to} onClick={close} to={to}>{t(key,key)}</Link>)}</div>
        <Link onClick={close} to="/fancy-color-diamonds.html">{t('navDiamonds','FANCY COLOUR DIAMONDS')}</Link>
        <Link onClick={close} to="/maison.html">{t('navHouse','Maison')}</Link>
        <Link onClick={close} to="/founder.html">{t('navFounder','Founder')}</Link>
        <Link onClick={close} to="/payment.html">{t('navPayment','Payment')}</Link>
        <Link onClick={close} to={profile?'/account.html':'/member.html'}>{memberLabel}</Link>
      </nav>
    </header>
  </>;
}
